// Side rail stats for the dashboard — weekly totals and highlights
import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { StatBlock } from '@/components/ui/SharedComponents';
import { formatHours } from '@/components/ui/formatHours';
import { CAPACITY_WARNING_COLOR } from '@/utils/colorUtils';
import { useT } from '@/i18n/useT';

export default function DashboardSideRail({
  totalHours,
  totalTasks,
  delta,
  activeDays,
  bestDay,
  biggestTask,
}) {
  const t = useT();

  return (
    <Box data-testid="dashboard-side-rail" sx={{ flex: '0 0 220px' }} inert>
      <StatBlock
        value={formatHours(totalHours)}
        label={t('dashboard.totalHours', 'voltooid deze week')}
      />
      {totalTasks > 0 ? (
        <StatBlock
          value={totalTasks}
          label={t('dashboard.totalTasks', 'taken voltooid')}
        />
      ) : null}
      {delta !== null && delta !== undefined && delta !== 0 ? (
        <StatBlock
          value={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
              }}
            >
              {delta >= 0 ? (
                <TrendingUpIcon sx={{ fontSize: 18, color: 'success.main' }} />
              ) : (
                <TrendingDownIcon
                  sx={{ fontSize: 18, color: CAPACITY_WARNING_COLOR }}
                />
              )}
              <Box component="span" sx={{ fontSize: 19, fontWeight: 600 }}>
                {delta >= 0 ? '+' : ''}
                {formatHours(Math.abs(delta))}
              </Box>
            </Box>
          }
          label={t('dashboard.delta', 't.o.v. vorige week')}
        />
      ) : null}
      {activeDays > 0 ? (
        <StatBlock
          value={activeDays}
          label={t('dashboard.activeDays', 'actieve dagen')}
        />
      ) : null}
      {bestDay ? (
        <StatBlock
          value={bestDay}
          label={t('dashboard.bestDay', 'beste dag')}
          dense
        />
      ) : null}
      {biggestTask ? (
        <StatBlock
          value={
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {biggestTask.title}
            </Typography>
          }
          label={t('dashboard.biggestTask', 'grootste taak — {meta}', {
            meta: biggestTask.meta,
          })}
          dense
        />
      ) : null}
    </Box>
  );
}
